import styled from "styled-components";

const Divider = styled.hr`
  width: 100%;
  height: 1px;
  background: #484848;
  margin: 0;
  border: none;
`;

export default Divider;
